export default __webpack_public_path__ + "static/media/tv-crp2.6563c116.png";